'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSentryLogger = undefined;

var _devLogger = require('../logger/devLogger');

var devLogger = _interopRequireWildcard(_devLogger);

var _RavenWrapper = require('./RavenWrapper');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Create a logger that buffers the maxLines most recent logs and sends them to sentry in
 * extra data if an exception occurs.
 *
 * Use this judiciously; there is a 200kb cap on individual event payloads.
 *
 * https://docs.sentry.io/enriching-error-data/context/?platform=browser#extra-context
 *
 * @example
 * const logger = createSentryLogger({ maxLines: 5, sentryDataKey: 'testDebugLogs' });
 *
 * logger.log('this is a test');
 * // Sentry context is now { testDebugLogs: [['this is a test']] }
 * logger.log('this can capture useful info', 123);
 * // Sentry context is now { testDebugLogs: [['this is a test'], ['this can capture useful info', 123]] }
 *
 *
 * @param {Object} options - options
 * @param {Number} options.maxLines - maximum amount of lines to buffer
 * @param {String} options.sentryDataKey - context key to set
 * @returns {Object} An enhanced logger with the console api
 */
var createSentryLogger = exports.createSentryLogger = function createSentryLogger(_ref) {
  var _ref$maxLines = _ref.maxLines,
      maxLines = _ref$maxLines === undefined ? 25 : _ref$maxLines,
      sentryDataKey = _ref.sentryDataKey;

  if (maxLines > 100) {
    throw new Error('Max lines cannot exceed 100');
  }

  if (typeof sentryDataKey !== 'string') {
    throw new Error('`sentryDataKey` is required');
  }

  var lines = [];

  var buildLogger = function buildLogger(methodName) {
    return function () {
      for (var _len = arguments.length, line = Array(_len), _key = 0; _key < _len; _key++) {
        line[_key] = arguments[_key];
      }

      var timestamp = new Date().toISOString();
      lines.push([timestamp].concat(line));

      if (lines.length > maxLines) {
        lines.shift();
      }

      (0, _RavenWrapper.setExtraContext)(_defineProperty({}, sentryDataKey, lines));

      devLogger[methodName].apply(devLogger, line);
    };
  };

  return {
    error: buildLogger('error'),
    info: buildLogger('info'),
    log: buildLogger('log'),
    trace: buildLogger('trace'),
    warn: buildLogger('warn')
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-infrastructure/static-1.19/js/sentry/createSentryLogger.js
// module id = 774
// module chunks = 2 3